<app-stages [stages]="stages" currentStage="Dane miejsca na cmentarzu"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <div class="row">
      <div class="col-md-6">
        <div class='form-group' *ngIf='"cemeteryName" as controlName'>
          <label [for]='controlName'>
            Nazwa cmentarza *
          </label>
          <select
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            @for (item of form.cemeteryNames; track $index) {
              <option [value]='item'>{{ item }}</option>
            }
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      @if (application()?.service?.url === '/wniosek-o-miejsce-na-cmentarzu') {
        <div class="col-md-4">
          <div class='form-group' *ngIf='"graveType" as controlName'>
            <label [for]='controlName'>
              Typ grobu *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <optgroup label="Ziemny">
                <option value='Ziemny, Miejsce pojedyńcze'>Miejsce pojedyńcze (Ziemny)</option>
                <option value='Ziemny, Miejsce podwójne'>Miejsce podwójne (Ziemny)</option>
                <option value='Ziemny, Miejsce urnowe'>Miejsce urnowe (Ziemny)</option>
              </optgroup>
              <optgroup label="Murowany">
                <option value='Murowany, Miejsce pojedyńcze'>Miejsce pojedyńcze (Murowany)</option>
                <option value='Murowany, Miejsce podwójne'>Miejsce podwójne (Murowany)</option>
                <option value='Murowany, Miejsce urnowe'>Miejsce urnowe (Murowany)</option>
              </optgroup>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      } @else {
        <div class="col-md-4">
          <div class='form-group' *ngIf='"graveType" as controlName'>
            <label [for]='controlName'>
              Typ grobu *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option value="Rezerwacja, Miejsce pojedyńcze">Miejsce pojedyńcze (Rezerwacja)</option>
              <option value="Rezerwacja, Miejsce podwójne">Miejsce podwójne (Rezerwacja)</option>
              <option value="Rezerwacja, Miejsce urnowe">Miejsce urnowe (Rezerwacja)</option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    <div class="row">
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"graveSector" as controlName'>
          <label [for]='controlName'>
            Sektor *
          </label>
          <input
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu sektor'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"graveRow" as controlName'>
          <label [for]='controlName'>
            Rząd *
          </label>
          <input
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu rząd'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"graveNumber" as controlName'>
          <label [for]='controlName'>
            {{ application() | graveNumberLabel }} *
          </label>
          <input
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            [placeholder]='application() | graveNumberPlaceholder'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <p id="soleGraveAdminDesc">Oświadczam, że jestem jednym dysponentem grobu *</p>
        <br>
        <div class="form-group" *ngIf='"soleGraveAdmin" as controlName'>
          <div class="custom-radio custom-inline" [ngClass]='{ "is-invalid": form.showError(controlName) }'>
            <input
              aria-describedby="soleGraveAdminDesc"
              (change)="form.soleGraveAdminChange(true)"
              [formControlName]="controlName"
              type="radio"
              [id]="controlName + 'Yes'"
              [value]="true">
            <label [for]="controlName + 'Yes'">Tak</label>
          </div>
          <div class="custom-radio custom-inline" [ngClass]='{ "is-invalid": form.showError(controlName) }'>
            <input
              aria-describedby="soleGraveAdminDesc"
              (change)="form.soleGraveAdminChange(false)"
              [formControlName]="controlName"
              type="radio"
              [id]="controlName + 'No'"
              [value]="false">
            <label [for]="controlName + 'No'">Nie</label>
          </div>
          <app-validation-errors [control]='form.soleGraveAdmin'>
          </app-validation-errors>
        </div>
      </div>
      @if (form.numberOfRemainingDisposers) {
        <div class="col-md-3">
          <div class='form-group' *ngIf='"numberOfRemainingDisposers" as controlName'>
            <label [for]='controlName'>
              Ilość pozostałych dysponentów *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu ilość'
              mask="0*"
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    @if (form.showPersonDataControls) {
      <fieldset>
        <legend>
          Dane osoby która ma zostać pochowana
        </legend>
        <div class="row">
          <div class="col-md-4">
            <div class='form-group' *ngIf='"personFirstName" as controlName'>
              <label [for]='controlName'>
                Imię *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu imię'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class="col-md-4">
            <div class='form-group' *ngIf='"personLastName" as controlName'>
              <label [for]='controlName'>
                Nazwisko *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu nazwisko'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
        <div class='row'>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"dateOfBirth" as controlName'>
              <label [for]='controlName'>
                Data urodzenia *
              </label>
              <app-date-picker [id]='controlName' [formControlName]='controlName'>
              </app-date-picker>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"dateOfDeath" as controlName'>
              <label [for]='controlName'>
                Data śmierci *
              </label>
              <app-date-picker [id]='controlName' [formControlName]='controlName'>
              </app-date-picker>
              <app-validation-errors
                fieldLabel='Data śmierci'
                secondFieldLabel='dacie urodzenia'
                [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-12">
            <div class='form-group' *ngIf='"declarationOfDataAccuracy" as controlName'>
              <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                <input
                  [formControlName]='controlName'
                  type='checkbox'
                  [id]='controlName'
                  [name]='controlName'>
                <label [for]='controlName'>
                  * Oświadczam, że dane zawarte w deklaracji podano zgodnie z prawdą
                </label>
              </div>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      </fieldset>
    }
  </form>
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
